import http from './http'

export function listAgents() {
  return http.get('/ai/agents')
}

export function createAgent(payload) {
  return http.post('/ai/agents', payload)
}

export function updateAgent(id, payload) {
  return http.put(`/ai/agents/${id}`, payload)
}

export function deleteAgent(id) {
  return http.delete(`/ai/agents/${id}`)
}

export function runAgent(id, payload) {
  return http.post(`/ai/agents/${id}/run`, payload)
}

export function listRuns() {
  return http.get('/ai/runs')
}

export function listTemplates() {
  return http.get('/ai/templates')
}

export function getTemplate(id) {
  return http.get(`/ai/templates/${id}`)
}

export function createTemplate(payload) {
  return http.post('/ai/templates', payload)
}

export function updateTemplate(id, payload) {
  return http.put(`/ai/templates/${id}`, payload)
}

export function deleteTemplate(id) {
  return http.delete(`/ai/templates/${id}`)
}

export function generateLayerText(payload) {
  return http.post('/ai/studio/generate-text', payload)
}

export function studioCreatePost(payload) {
  return http.post('/ai/studio/create-post', payload)
}

export function importCanva(payload) {
  return http.post('/ai/studio/import-canva', payload)
}

export function listCanvaImportJobs() {
  return http.get('/ai/studio/import-canva/jobs')
}

export function getCanvaImportJob(id) {
  return http.get(`/ai/studio/import-canva/jobs/${id}`)
}

export function reportCanvaImport(payload) {
  return http.post('/ai/studio/canva-import-reports', payload)
}

export function listStudioFonts() {
  return http.get('/ai/studio/fonts')
}

export function generateContent(payload) {
  return http.post('/ai/generate', payload)
}

export function suggestSchedule(payload) {
  return http.post('/ai/schedule', payload)
}

export function generateAndCreate(payload) {
  return http.post('/ai/generate-post', payload)
}
